import {createListenerMiddleware} from '@reduxjs/toolkit';
import {LocationChangeAction} from 'connected-react-router';
import {matchPath} from 'react-router-dom';
import {updateFilteredFacilities} from 'pages/facilities/store/facilities-actions';
import {RootState} from 'store/store';
import {flattenObjectValues} from 'utils/format-strings';
import {ROUTES} from 'constants/app-routes';

const facilityLocationMiddleware = createListenerMiddleware<RootState>();

/**
 * Listens for location changes in the router and triggers an action to sync the filtered facilities when the user clicks either the forward or back button.
 */
facilityLocationMiddleware.startListening({
    type: '@@router/LOCATION_CHANGE',
    effect: (action: LocationChangeAction, listenerApi) => {
        if (action.payload.action !== 'POP') {
            return;
        }

        const {pathname} = action.payload.location;
        const flattenedRoutes = flattenObjectValues(ROUTES);
        const match = matchPath(pathname, {
            path: flattenedRoutes,
            exact: true,
            strict: true,
        });
        const facilityIdParam = match?.params?.facilityId ?? null;
        const facilityId =
            facilityIdParam !== null ? Number(facilityIdParam) : null;
        const {selectedFacilityId} = listenerApi.getState().facilities;

        if (facilityIdParam && facilityIdParam !== selectedFacilityId) {
            listenerApi.dispatch(updateFilteredFacilities(facilityId));
        }
    },
});

export default facilityLocationMiddleware;
